module.exports = __webpack_public_path__ + "static/media/thin-leaves-plant.38c278ad.fbx";